var _defs, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:#f5f5f5}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__iconfinder_38-instagram_1161953",
    transform: "translate(-2.4 -3.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Trazado_50",
    "data-name": "Trazado 50",
    style: {
      fill: "#77777c"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.513 25.3H9.287c-1.807 0-3.377-.592-4.54-1.712C3.538 22.422 2.9 20.806 2.9 18.913v-8.266c0-1.857.607-3.445 1.754-4.593C5.802 4.907 7.39 4.3 9.247 4.3h8.306c1.84 0 3.47.64 4.59 1.803 1.15 1.15 1.757 2.722 1.757 4.544v8.306c0 1.894-.625 3.497-1.806 4.635-1.166 1.12-2.75 1.712-4.581 1.712z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.247 4.8C5.739 4.8 3.4 7.139 3.4 10.647v8.266c0 1.734.565 3.226 1.694 4.314 1.088 1.049 2.54 1.573 4.193 1.573h8.226c1.734 0 3.185-.565 4.234-1.573 1.088-1.048 1.653-2.54 1.653-4.274v-8.306c0-1.694-.565-3.145-1.613-4.194C20.74 5.365 19.247 4.8 17.553 4.8H9.247m0-1h8.306c1.975 0 3.731.693 4.948 1.953C23.743 6.999 24.4 8.69 24.4 10.647v8.306c0 2.033-.678 3.76-1.96 4.995-1.26 1.212-2.964 1.852-4.927 1.852H9.287c-1.939 0-3.629-.64-4.887-1.852-1.309-1.262-2-3.003-2-5.035v-8.266c0-1.992.657-3.703 1.9-4.946C5.545 4.457 7.256 3.8 9.248 3.8z",
    style: {
      stroke: "none",
      fill: "#f5f5f5"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_49",
    d: "M20.57 16.7a5.17 5.17 0 105.17 5.17 5.18 5.18 0 00-5.17-5.17zm0 8.482a3.312 3.312 0 113.312-3.312 3.327 3.327 0 01-3.312 3.312z",
    className: "prefix__cls-2",
    "data-name": "Trazado 49",
    transform: "translate(-7.17 -7.11)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Elipse_10",
    cx: 1.167,
    cy: 1.167,
    r: 1.167,
    className: "prefix__cls-2",
    "data-name": "Elipse 10",
    transform: "translate(17.597 8.309)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.be26f3e460128d870da47739371673b0.svg";
export { ForwardRef as ReactComponent };